import { useAuthContext } from '../contexts/auth-context';
import { readSignupIntent, type SignupIntent } from '../lib/auth/signup-intent';

/**
 * Intenção do cadastro da sessão atual (T1.19b, ADR 0039).
 *
 * Hook próprio, e não um campo novo no `useAuth`: a forma `{ isAuthenticated, role, isLoading }` é
 * contrato do `AppRouter`, travado por teste. Decide só **navegação** — nunca acesso a dados.
 */
export function useSignupIntent(): SignupIntent | null {
  const { user } = useAuthContext();
  return readSignupIntent(user);
}
